"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _core = require("../core");

var _utils = require("../utils");

var BORDER_WIDTH = 4;
var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    root: {
      paddingLeft: "".concat(BORDER_WIDTH, "px")
    },
    expanded: {
      paddingLeft: 'unset',
      borderLeft: "".concat(BORDER_WIDTH, "px solid ").concat(theme.palette.primary.main)
    }
  };
}, {
  name: (0, _core.rochePrefix)('ExpansionPanel')
});
exports.useStyles = useStyles;